<template>
  <tr v-if="!esEditable">
    <td class="text-right">
      <button class="btn btn-xs btn-icon btn-light-primary" @click="$root.$emit('show:privado:itinerario', item)">
        <i class="fa fa-eye"></i>
      </button>
      <template v-if="!estaLiquidado">
        <button class="btn btn-xs btn-icon btn-light-warning ml-1" @click="onEdit">
          <i class="fa fa-pen"></i>
        </button>
        <button class="btn btn-xs btn-icon btn-light-danger ml-1" @click="onDelete" :disabled="loading.save">
          <i class="fa fa-trash-alt"></i>
        </button>
      </template>
      <button class="btn btn-xs btn-icon btn-light-success ml-1" @click="$root.$emit('show:privado:liquidacion', item)">
        <i class="fa fa-dollar-sign"></i>
      </button>
    </td>
    <td class="text-center">
      <template>{{ item.codigo }}</template>
    </td>
    <td>
      <template>{{ item.agencia }}</template>
    </td>
    <td class="text-center">
      <template>{{ item.docVenta }}</template>
    </td>
    <td class="text-center">
      <template>{{ item.fechaLlegada | date }}</template>
    </td>
    <td class="text-center">
      <template>{{ item.fechaSalida | date }}</template>
    </td>
    <td class="text-center">
      <template>{{ item.idioma }}</template>
    </td>
    <td class="text-center">
      <template>{{ item.nroAdultos }}</template>
    </td>
    <td class="text-center">
      <template>{{ item.nroNinos }}</template>
    </td>
    <td class="text-center">
      <template>{{ item.nroDocVenta }}</template>
    </td>
    <td>
      <template>{{ item.pasajero }}</template>
    </td>
  </tr>
  <ValidationObserver v-else tag="tr" ref="form" :vid="String(item.idPrivado)">
    <td class="text-center">
      <button class="btn btn-xs btn-icon btn-light-primary" @click="onSave" :disabled="loading.save">
        <i class="fa fa-check"></i>
      </button>
      <button class="btn btn-xs btn-icon btn-secondary ml-1" @click="onRemove" :disabled="loading.save">
        <i class="fa fa-times"></i>
      </button>
    </td>
    <td class="text-center"></td>
    <td>
      <InputSelect
        v-model="item.tempAgencia"
        :errorMode="'tooltip'"
        :vid="`agencia_${item.idPrivado}`"
        name="Agencia"
        rules="required"
        :options="agencias"
        label="nombre"
        input-class="form-control-table"
      ></InputSelect>
    </td>
    <td class="text-center">
      <InputSelect
        v-model="item.tempDocVenta"
        :errorMode="'tooltip'"
        :vid="`docVenta_${item.idPrivado}`"
        name="Doc. Venta"
        :options="docsVenta"
        label="nombre"
        input-class="form-control-table"
      ></InputSelect>
    </td>
    <td class="text-center">
      <InputDatepicker
        v-model="item.tempFechaLlegada"
        :errorMode="'tooltip'"
        :vid="`fechaLlegada_${item.idPrivado}`"
        name="Fecha Llegada"
        rules="required"
        :editable="false"
        :inputClass="'form-control form-control-table'"
      ></InputDatepicker>
    </td>
    <td class="text-center">
      <InputDatepicker
        v-model="item.tempFechaSalida"
        :errorMode="'tooltip'"
        :vid="`fechaSalida_${item.idPrivado}`"
        name="Fecha Salida"
        rules=""
        :editable="false"
        :inputClass="'form-control form-control-table'"
      ></InputDatepicker>
    </td>
    <td class="text-center">
      <InputSelect
        v-model="item.tempIdioma"
        :errorMode="'tooltip'"
        :vid="`idioma_${item.idPrivado}`"
        name="Idioma"
        rules="required"
        :options="idiomas"
        label="abreviatura"
        input-class="form-control-table"
      ></InputSelect>
    </td>
    <td class="text-center">
      <InputText
        v-model="item.tempPAX"
        :errorMode="'tooltip'"
        :vid="`pax_${item.idPrivado}`"
        name="PAX"
        rules="required|numeric"
        :inputClass="'form-control form-control-table text-center'"
      ></InputText>
    </td>
    <td class="text-center">
      <InputText
        v-model="item.tempCHD"
        :errorMode="'tooltip'"
        :vid="`chd_${item.idPrivado}`"
        name="CHD"
        rules="numeric"
        :inputClass="'form-control form-control-table text-center'"
      ></InputText>
    </td>
    <td class="text-center">
      <InputText
        v-model="item.tempNroDocVenta"
        :errorMode="'tooltip'"
        :vid="`nroDocVenta_${item.idPrivado}`"
        name="Nro. Doc. Venta"
        rules=""
        :inputClass="'form-control form-control-table text-center'"
      ></InputText>
    </td>
    <td>
      <InputText
        v-model="item.tempPasajero"
        :errorMode="'tooltip'"
        :vid="`pasajero_${item.idPrivado}`"
        name="Pasajero"
        rules="required"
        :inputClass="'form-control form-control-table'"
      ></InputText>
    </td>
  </ValidationObserver>
</template>

<script>
import InputDatepicker from "../../shared/components/InputDatepicker.vue";
import InputText from "../../shared/components/InputText.vue";
import InputSelect from "../../shared/components/InputSelect.vue";
import { mapState } from "vuex";

export default {
  components: { InputSelect, InputText, InputDatepicker },
  props: {
    item: Object,
  },
  data() {
    return {
      loading: {
        save: false,
      },
    };
  },
  computed: {
    esEditable() {
      return this.item.isNew || this.item.isEdit;
    },
    estaLiquidado () {
      return this.item.idLiquidacion ? true : false;
    },
    ...mapState("privados", ["agencias", "docsVenta", "idiomas"]),
  },
  methods: {
    async onSave() {
      const vm = this;
      const validated = await this.$refs.form.validate();

      if (!validated) return;

      vm.loading.save = true;

      const fd = {
        fechaLlegada: vm.item.tempFechaLlegada,
        fechaSalida: vm.item.tempFechaSalida || null,
        pasajero: vm.item.tempPasajero || null,
        agencia: vm.item.tempAgencia.idAgencia,
        nroAdultos: vm.item.tempPAX,
        nroNinos: vm.item.tempCHD || null,
        idioma: vm.item.tempIdioma.idIdioma,
        docVenta: vm.item.tempDocVenta || null,
        nroDocVenta: vm.item.tempNroDocVenta || null,
      };

      const endpoint = vm.item.isEdit ? vm.axios.put(`/privados/${vm.item.idPrivado}`, fd) : vm.axios.post("/privados", fd);

      endpoint
        .then((response) => {
          vm.$toast.fire("", response.data.message, "success");
          if (!vm.item.isNew) {
            this.$store.dispatch("privados/saveItem", vm.item.idPrivado);
          }
          vm.$emit("store");
        })
        .finally(() => {
          vm.loading.save = false;
        });
    },
    onEdit() {
      this.$store.dispatch("privados/editItem", this.item.idPrivado);
    },
    onCancel() {
      this.item.isEdit = false;
    },
    onRemove() {
      if (this.item.isEdit) return this.onCancel();

      this.$store.dispatch("privados/removeItem", this.item.idPrivado);
    },
    async onDelete() {
      const vm = this;
      const result = await vm.$confirm.fire("", "¿Estás seguro de eliminar este registro?");
      if (!result.value) return;

      vm.loading.save = true;

      vm.axios
        .delete(`/privados/${vm.item.idPrivado}`)
        .then((response) => {
          vm.$toast.fire("", response.data.message, "success");
          this.$store.dispatch("privados/removeItem", vm.item.idPrivado);
          vm.$emit("store");
        })
        .catch((err) => {
          vm.loading.save = false;
        });
    },
  },
};
</script>

<style></style>
